// JsFromRoutes CacheKey 59ce51711a730cc7df0f7d6988e1b31f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  hsa: /* #__PURE__ */ definePathHelper('get', '/members/dashboard/hsa'),
  ichra: /* #__PURE__ */ definePathHelper('get', '/members/dashboard/ichra'),
  resolution: /* #__PURE__ */ definePathHelper('get', '/members/dashboard/resolution'),
  index: /* #__PURE__ */ definePathHelper('get', '/'),
}
